import * as React from 'react';
import {createBrowserHistory, History} from 'history';
import {RegisterAccountAppShell} from '@practicegenius/register-account/src/App';
import {makeNoAuthApiClient} from '@practicegenius/http-clients-js/src/ApiClient';
import {useHistoryRouter} from '../../shared/hooks/useHistoryRouter';
import {PG_CORE_URL} from '../../constants/env';
import * as Screens from './screens';
import {isGenericHub} from '../../utils/practice';
import {GateKeepUserWithoutToken} from './components/GateKeepUserWithoutToken';
import {WarnBeforeLeaving} from './components/WarnBeforeLeaving';
import appLogger from '../../utils/logger';
import {HistoryNavigator} from './HistoryNavigator';
import {getWebsocket} from '../../utils/websocket';
import {basename} from './routes';
import {UnauthenticatedStandardProvider} from '../../components/StandardProvider';
import {sitesHttpClient} from '../../http/AuthApiProvider';

type ShellProps = React.ComponentProps<typeof RegisterAccountAppShell>;

const ProtectRoute: ShellProps['RouteProtection'] = ({
  registrationMachine,
  children,
}) => (
  <GateKeepUserWithoutToken registrationMachine={registrationMachine}>
    <WarnBeforeLeaving registrationMachine={registrationMachine}>
      {children}
    </WarnBeforeLeaving>
  </GateKeepUserWithoutToken>
);

type AppProps = {
  history: History;
  isGenericHub: typeof isGenericHub;
};

export default function App({
  history = createBrowserHistory({basename}),
  isGenericHub,
}: AppProps) {
  return (
    <UnauthenticatedStandardProvider>
      <RegisterAccountAppShell
        logger={appLogger}
        navigator={new HistoryNavigator(history)}
        coreApiClient={makeNoAuthApiClient({
          baseURL: PG_CORE_URL,
        })}
        sitesDotClient={sitesHttpClient}
        useRouter={useHistoryRouter}
        RouteProtection={ProtectRoute}
        screens={Screens}
        containerProps={{
          isGenericHub,
          pgCoreUrl: PG_CORE_URL,
          getWebsocket,
          showAlert: alert,
          redirect: {
            toLogin: () => {
              window.location.href = '/login';
            },
            toLoginAsUser: identifier => {
              window.location.href = `/login?user=${identifier}`;
            },
            toSocialLoginWithProvider: socialProvider => {
              window.location.href = `/login/social_provider/${socialProvider}`;
            },
            toAnywhere: path => {
              window.location.href = path;
            },
          },
        }}
      />
    </UnauthenticatedStandardProvider>
  );
}

App.defaultProps = {
  isGenericHub,
};
